import { createContext, useContext } from "react";

const CreateIntercomContext = createContext({});

export const CreateIntercomContextProvider = CreateIntercomContext.Provider;
export const CreateIntercomContextConsumer = CreateIntercomContext.Consumer;

export const useIntercomContext = () => useContext(CreateIntercomContext);

export default CreateIntercomContext;
